document.addEventListener('DOMContentLoaded', () => {
  if (localStorage.getItem('descUpdated')) {
    alert('Updated successfully!')
    localStorage.removeItem('descUpdated')
  }

  $('.cp_second_level__table-action-icon').click(function (e) {
    e.preventDefault()
    var id = $(this).data('id')
    var title = $('.title-' + id).val()
    var position = $('.position-' + id).val()
    var description = $('.description-' + id).val()
    $.ajax({
      url: '/admin/cp_second_levels/update_second_level',
      data: { id: id, title: title, position: position, description: description },
      type: 'POST',
    })
      .done(function (data) {
        localStorage.setItem('descUpdated', true)
        location.reload()
      })
      .fail(function () {
        alert('Update failed.')
      })
  })
})
